import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import './i18n'
import App from './App'
import './index.css'
import { ThemeProvider } from '@/components/ThemeProvider'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <Suspense
        fallback={
          <div className="flex h-screen items-center justify-center bg-background">
            <span className="text-muted-foreground">Loading…</span>
          </div>
        }
      >
        <App />
      </Suspense>
    </ThemeProvider>
  </React.StrictMode>,
)
